import { useGebruikerContext } from "Pages/Coordinator/Gebruikers/Context/GebruikerContext";
import { useContext, createContext, useState, useMemo } from "react";
import { useSelector } from "react-redux";


export const DocumentenContext = createContext();

export const useDocumentenContext = () => {
	const context = useContext(DocumentenContext);
	if (!context) throw new Error("Use documenten context within provider.");
	return context;
};

export const DocumentenProvider = ({ children }) => {
	const { userDetails } = useGebruikerContext();

	const userProfileImage = useSelector((state) => state.UserProfile.profileImage);
	const [openModel, setOpenModel] = useState(false);
	const [file, setFile] = useState("");
	const [image, setImage] = useState(userProfileImage);

	const toggleProfileCropPopup = (val) => {
		setOpenModel(val);
		if (val === false) {
			setFile("");
		}
	};
	const handleCroppedImage = (val) => {
		if (val !== "") {
			setImage(val);
		}
	};

	const saveFile = (file) => {
		setFile(file);
	};

	const { docsTableList, subsTableList } = useMemo(() => {
		if (!userDetails || !Array.isArray(userDetails))
			return { docsTableList: [], subsTableList: [] };

		return {
			docsTableList: userDetails
				.map((item) => item.docs)
				.filter((item) => item !== null && item !== undefined && item !== ""),
			subsTableList: userDetails
				.map((item) => item.toegevoegd)
				.filter((item) => item !== null && item !== undefined && item !== ""),
		};
	}, [userDetails]);

	return (
		<DocumentenContext.Provider
			value={{
				openModel,
				setOpenModel,
				file,
				setFile,
				image,
				setImage,
				docsTableList,
				subsTableList,
				toggleProfileCropPopup,
				handleCroppedImage,
				saveFile,
			}}
		>
			{children}
		</DocumentenContext.Provider>
	);
};
